module.exports = __webpack_public_path__ + "img/zzzx-logo.44369728.jpg";